import { EcardEditorSwitch } from './EcardEditorSwitch';
export default EcardEditorSwitch;
